import React from 'react';
import { Select as MuiSelect, InputLabel, FormControl } from '@mui/material';

export default function Select({
  id,
  label,
  value,
  children,
  error,
  onChange,
  size,
  sx,
  ...props
}) {
  return (
    <FormControl variant="standard" size={size} sx={sx}>
      {label && (
        <InputLabel shrink htmlFor={id}>
          {label}
        </InputLabel>
      )}
      <MuiSelect
        native
        id={id}
        value={value}
        error={error}
        onChange={onChange}
        size={size}
        {...props}
      >
        {children}
      </MuiSelect>
    </FormControl>
  );
}
